import { useLang } from '@/app/utils/useLang';
import styles from './index.module.scss';
import BlackButton from '../BlackButton';
import StepIcon1 from './icons/StepIcon1';
import StepIcon2 from './icons/StepIcon2';
import StepIcon3 from './icons/StepIcon3';
import StepIcon4 from './icons/StepIcon4';
import Icon from './Icon';
import gtm from '@/utils/gtm';

interface ProcessProps {
    onJoinNow: () => void;
    onMyMysteryBox: () => void;
    isLoggedIn: boolean;
    campaignId?: string | number;
}

const Process: React.FC<ProcessProps> = ({ onJoinNow, onMyMysteryBox, isLoggedIn, campaignId }) => {
    const { t } = useLang('Process');

    const steps = [
        {
            key: 'query',
            icon: <StepIcon1 />,
            title: t('step1'),
            desc: t('step1_desc'),
        },
        {
            key: 'draw',
            icon: <StepIcon2 />,
            title: t('step2'),
            desc: t('step2_desc'),
        },
        {
            key: 'return',
            icon: <StepIcon3 />,
            title: t('step3'),
            desc: t('step3_desc'),
        },
        {
            key: 'receive',
            icon: <StepIcon4 />,
            title: t('step4'),
            desc: t('step4_desc'),
        },
    ];

    function handleJoinNow() {
        onJoinNow();
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('join_now'),

            __btn_id1: 'service-renewal-process-join-now',
            __btn_id2: 'service-renewal-process-join-now',
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    }

    function handleMyMysteryBox() {
        onMyMysteryBox();

        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_join',
            button_name: t('my_mystery_box'),
        });
    }

    return (
        <div className={`${styles.Process} GtmModuleData-section sr-layout-sub`} data-section-id="service-renewal-process" id="process">
            <div className="">
                <div className="process-header">
                    <h2 className="sr-layout-sub-title">
                        <span className="title-dot">
                            <Icon />
                        </span>
                        {t('title')}
                    </h2>
                    <p className="process-desc">{t('desc')}</p>
                </div>
                <ul className="steps-list">
                    {steps.map((step, index) => (
                        <li key={step.key} className="step-item">
                            <div className="step-icon">{step.icon}</div>
                            <div>
                                <div className="step-title">Step {index + 1}</div>
                                <div className="step-title">{step.title}</div>
                            </div>
                            <div className="step-desc">{step.desc}</div>
                        </li>
                    ))}
                </ul>

                {/* <div className="btns">
                    <BlackButton
                        className="GtmModuleData-btn-common service-renewal-process-join-now"
                        data-btn-id="service-renewal-process-join-now"
                        type="primary"
                        shape="round"
                        onClick={handleJoinNow}
                        disabled={!campaignId}
                    >
                        {t('join_now')}
                    </BlackButton>
                    {isLoggedIn && (
                        <BlackButton
                            className="GtmModuleData-btn-common service-renewal-process-my-mystery-box"
                            data-btn-id="service-renewal-process-my-mystery-box"
                            type="default"
                            shape="round"
                            onClick={handleMyMysteryBox}
                            disabled={!campaignId}
                        >
                            {t('my_mystery_box')}
                        </BlackButton>
                    )}
                </div> */}
            </div>
        </div>
    );
};

export default Process;
